import { Checkbox as HeadlessCheckbox } from '@headlessui/react'
import { FaCheck } from 'react-icons/fa'
import { FaX } from 'react-icons/fa6'

export function Checkbox({
    checked,
    onChange,
    label = '',
    disabled = false,
    className = '',
    readOnly = false,
}) {
    // Handle click for readOnly - prevent changes but don't disable UI
    const handleChange = value => {
        if (!readOnly && !disabled) {
            onChange(value)
        }
    }

    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <HeadlessCheckbox
                checked={checked}
                onChange={handleChange}
                disabled={disabled || readOnly} // HeadlessCheckbox should still treat readOnly as disabled for interaction
                className={`group relative size-6 rounded-sm border-2 transition-colors
                    focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2
                    ${disabled || readOnly ? 'cursor-default' : 'cursor-pointer'}
                    ${
                        checked
                            ? 'bg-yellow-600 border-yellow-500 hover:border-yellow-400'
                            : 'border-yellow-300 hover:border-yellow-400'
                    }
                    ${readOnly && checked ? 'bg-yellow-500 border-yellow-400' : ''}
                `}
            >
                {checked && (
                    <FaCheck className='absolute inset-0 m-auto text-white scale-100 size-4' />
                )}
            </HeadlessCheckbox>

            {label && (
                <label
                    onClick={() => !readOnly && !disabled && onChange(!checked)}
                    className={`text-sm font-medium ${
                        disabled
                            ? 'opacity-50 hover:cursor-default'
                            : readOnly
                              ? 'hover:cursor-default'
                              : 'text-gray-700 cursor-pointer'
                    }`}
                >
                    {label}
                </label>
            )}
        </div>
    )
}
